import { Skeleton, Tooltip, tableHelpers } from '@round/creatorbase-ui';
import { getMeta, CellContext } from '../../helpers';
import styles from './CreatedByCell.module.css';

export const CreatedByCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading, getIsUserLoading } = getMeta(table);

    if (tableHelpers.isLoadingRow(original)) {
        return <Skeleton className={styles.skeleton} />;
    }

    if (isLoading || getIsUserLoading(original)) {
        return <Skeleton className={styles.skeleton} />;
    }

    const name = original.createdBy?.name ?? '-';

    return (
        <Tooltip>
            <Tooltip.TriggerOnOverflow asChild>
                <span className={styles.name}>{name}</span>
            </Tooltip.TriggerOnOverflow>
            <Tooltip.Content>{name}</Tooltip.Content>
        </Tooltip>
    );
};
